import React from "react";
import { PageShell } from "./PageShell";
import { PageIntro } from "../components/PageIntro";
import { Reporting } from "../components/sections/Reporting";

export default function ReportingPage() {
  return (
    <PageShell>
      <div className="pt-[72px]">
        <PageIntro contentKey="reporting" />
        <Reporting hideIntro />
      </div>
    </PageShell>
  );
}
